import React from 'react';
import styled from 'styled-components';
import { ReactComponent as _CopyIcon } from 'styles/icons/copy-icon.svg';
import { ReactComponent as _CutIcon } from 'styles/icons/cut-icon.svg';
import { ReactComponent as _CopySyncedIcon } from 'styles/icons/copy-synced-icon.svg';
import Form from 'components/form';
import { H2 as GenericH2 } from 'components/typography';
import { withModifiers } from 'utils/styles';
import { font, size } from 'styles/settings/typography';
import { color } from 'styles/settings';
import SimpleBar from 'simplebar-react';

export const NodesList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const CopyIcon = styled(_CopyIcon)`
  margin-right: 15px;
  position: relative;
  top: 3px;
`;

export const CutIcon = styled(_CutIcon)`
  margin-right: 15px;
  position: relative;
  top: 3px;
  color: ${color.brand.gold};
  ${withModifiers('disabled')`
    color: ${color.neutral.white};
  `}
`;

export const SyncIcon = styled(_CopySyncedIcon)`
  margin-right: 15px;
  position: relative;
  top: 3px;
`;

export const Counter = styled.div`
  position: relative;
  top: 1px;
  width: 26px;
  height: 26px;
  border-radius: 100%;
  line-height: 26px;
  text-align: center;
  background-color: ${color.neutral.plainBlack};
  color: ${color.neutral.white};
  ${font.content.semiBold};
  font-size: ${size.md};
  margin-left: 15px;
`;

export const SubmitButton = styled(Form.SubmitButton).attrs(({ count }) => {
  if (count) {
    return { iconRight: <Counter>{count}</Counter> };
  }
  return { secondary: true, disabled: true };
})``;

export const Title = styled(GenericH2)`
  ${font.title.bold};
  font-size: 46px;
  line-height: 81px;

  @media all and (max-width: 1200px) {
    font-size: 32px;
  }

  ${withModifiers('red')`
      font-size: 36px;
      color: ${color.ui.danger};
  `}
`;

export const Content = styled.div`
  margin: 30px 40px 85px 40px;
  max-height: 660px;
`;

export const ScrollableContainer = styled(SimpleBar)`
  @media all and (max-width: 1200px) {
    max-height: 360px;
  }

  max-height: 740px;
`;
